import * as React from 'react';

export interface UseDialogResult {
  isOpen: boolean;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
}

export const useDialog = (): UseDialogResult => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpenDialog = () => setIsOpen(true);
  const handleCloseDialog = () => setIsOpen(false);

  return {
    isOpen,
    handleOpenDialog,
    handleCloseDialog,
  };
};
